var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"app"}},[(_vm.user.id)?_c('Navbar',{on:{"updateUser":_vm.updateUser}}):_vm._e(),_c('router-view',{on:{"updateUser":_vm.updateUser}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }